import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

interface NextSteps {
  title: string;
  description: string;
}

@Component({
  selector: 'app-greeting-dialog',
  standalone: false,
  templateUrl: './greeting-dialog.component.html',
  styleUrl: './greeting-dialog.component.scss'
})
export class GreetingDialogComponent {
  dialogRef = inject(MatDialogRef<GreetingDialogComponent>);

  nextSteps: NextSteps[] = [
    {
      title: "Share & Edit your Key Results.",
      description: "Easily edit and send your work to teammates, coachers, or investors in one click."
    },
    {
      title: "Turn your idea into a real landing page",
      description: "Build a simple, beautiful page to showcase your idea to the world."
    },
    {
      title: "Coming Soon: Validation, EXIST...",
      description: "These features are still in development..."
    }
  ]


  close() {
    this.dialogRef.close();
  }
}
